module.exports = __webpack_public_path__ + "static/media/proyeccion_lines.63a01978.png";